/**
 * useMainContainerQuery
 *
 * Example:
 * const columnCount = useMainContainerQuery(
 *      ['XL', 'LG', 'MD'],
 *      [5, 4, 3],
 *      2
 * );
 *
 * or
 *
 * const matches = useMainContainerQuery();
 *
 */

import { useMainContainerQueryContext } from '../contexts/mainContainerQuery';

const useMainContainerQuery = (queries, values, defaultValue) => {

    const matches = useMainContainerQueryContext();

    if (!queries) {

        return matches;

    }

    const index = queries.findIndex(a => matches[a] === true);

    return typeof values[index] !== 'undefined' ? values[index] : defaultValue;

};

export default useMainContainerQuery;
